import { DefaultRootState, useDispatch, useSelector } from "react-redux";

import { initialWidgetsData } from "../../../../containers/WIdgetsSidebar/WidgetSidebarData";
import { setWidgetSettings } from "../../../../appRedux/actions/WidgetSettings";
import { addWidgetInSheet } from "../../../../appRedux/actions/Boards";
import { listElement } from "../ListBuildertypes";
import { Popconfirm } from "../../../BP2Components";

import IntlMessages from "../../../../util/IntlMessages";

import "../ListBuilder.less";
import { useState } from "react";
import ListPreviewModal from "./ListBuilderModals/ListPreviewModal";

interface ListBuilderActionsInterface {
   handleLiestEditForm: (row: listElement) => void;
   handleOpenParentFormEdit: (row: listElement) => void;
   handleCopyList: (listId: string, copyParentForm: boolean) => void;
   handleListDelete: (listId: string) => void;
   row: listElement;
   col: any;
   isEditLoading?: boolean;
}

const ListBuilderActions: React.FC<ListBuilderActionsInterface> = ({
   handleLiestEditForm,
   handleOpenParentFormEdit,
   handleCopyList,
   handleListDelete,
   row,
   col,
   isEditLoading,
}) => {
   const [isOpen, setIsOpen] = useState<boolean>(false);

   const { currentBoard } = useSelector((state: DefaultRootState) => state.boards);

   const dispatch = useDispatch();

   return (
      <div className="list-builder-action-button-container" title="Wyświetl formularz budulcowy">
         {/* working feature, commented for now */}
         {/* <button className="list-builder-action-button" onClick={() => handleShowForm(formId)}>
            <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
               article_shortcut
            </span>
         </button>
      */}
         <button
            onClick={() => handleLiestEditForm(row)}
            className="list-builder-action-button"
            title="Edytuj listę"
            disabled={isEditLoading}
         >
            <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
               {isEditLoading ? "hourglass_empty" : "edit"}
            </span>
         </button>
         <button
            onClick={() => handleOpenParentFormEdit(row)}
            className="list-builder-action-button"
            title="Edytuj formularz budulcowy"
         >
            <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
               edit_document
            </span>
         </button>
         <Popconfirm
            okText={<IntlMessages id="yes" />}
            cancelText={<IntlMessages id="no" />}
            onConfirm={() => handleCopyList(row?.listId, true)}
            onCancel={() => handleCopyList(row?.listId, false)}
            title={<IntlMessages id="copy.parent.form.also?" />}
         >
            <button className="list-builder-action-button" title="Skopiuj listę">
               <span className="material-symbols-outlined">content_copy</span>
            </button>
         </Popconfirm>
         <button
            title="Wyświetl listę"
            className="list-builder-action-button"
            onClick={() => setIsOpen(!isOpen)}
         >
            <span className="material-symbols-outlined">quick_reference_all</span>
         </button>
         <Popconfirm
            onConfirm={() => handleListDelete(row?.listId)}
            title={<IntlMessages id="sure.to.delete?" />}
         >
            <button
               title="Usuń listę"
               style={{ color: "red" }}
               className="list-builder-action-button"
            >
               <span className="material-symbols-outlined">delete</span>
            </button>
         </Popconfirm>
         <ListPreviewModal listId={row?.listId} isOpen={isOpen} setIsOpen={setIsOpen} />
      </div>
   );
};

export default ListBuilderActions;
